import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AditivoIrcpIrfe } from '../../models/aditivo-ircp-irfe.model';
import { ActivatedRoute, Router } from '@angular/router';
import { IrfeProjetoService } from '../../services/irfe-projeto.service';
import { IrcpProjetoService } from '../../services/ircp-projeto.service';
import { FormBuilder, Validators } from '@angular/forms';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { MaskService } from 'src/app/shared/services/mask.service';
import { IrcpProjeto } from '../../models/ircp-projeto.model';
import { IrfeProjeto } from '../../models/irfe-projeto.model';
import { ToastrService } from 'ngx-toastr';
import { formatDate } from 'ngx-bootstrap/chronos';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-aditivo-ircp-irfe-edit',
  templateUrl: './aditivo-ircp-irfe-edit.component.html',
  styleUrls: ['./aditivo-ircp-irfe-edit.component.scss']
})
export class AditivoIrcpIrfeEditComponent extends BaseFormComponent<AditivoIrcpIrfe> implements OnInit {

  idProjeto: number;
  myId: number;
  isIrcp: boolean;
  canEdit: boolean = true;
  exibe_dt_end: boolean = false;
  exibe_transfer_value: boolean = false;
  exibe_counterpart_value: boolean = false;
  modelLabel: string = 'IRFE';
  actionLabel: string = 'Novo';
  myService: any;
  tiposAditivos: any[] = [];
  tiposParams: any = {};
  audit: AtualizacoesAudit;
  ircp: IrcpProjeto;
  irfe: IrfeProjeto;

  constructor(
    public activatedRoute: ActivatedRoute,
    private irfeService: IrfeProjetoService,
    private ircpService: IrcpProjetoService,
    private router: Router,
    private fb: FormBuilder,
    public maskService: MaskService,
    private toastr: ToastrService,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit() {
    this.tiposAditivos = this.activatedRoute.snapshot.data["tiposAditivos"].list;
    this.tiposParams = this.activatedRoute.snapshot.data["tiposAditivos"].params;
    this.isIrcp = this.activatedRoute.snapshot.data["isIrcp"];
    this.myId = this.activatedRoute.snapshot.params['id']; // ircp_id ou irfe_id

    if (this.isIrcp) {
      this.modelLabel = 'IRCP';
      this.myService = this.ircpService;
    } else {
      this.modelLabel = 'IRFE';
      this.myService = this.irfeService;
    }

    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = this.fb.group({
      dt_end: [''],
      transfer_value: ['0,00', /*[Validators.required]*/],
      counterpart_value: ['0,00', /*[Validators.required]*/],
      additive_type_id: [null, [Validators.required]],
    })

    if (this.entity) {
      this.form.patchValue(this.entity);
      this.canEdit = this.entity?.canEdit;

      this.exibeCampos();

      if (!this.canEdit) {
        this.form.disable();
      }

      if (this.entity.id) {
        this.actionLabel = 'Editar';

        if (this.isIrcp) {
          this.audit = {
            ircp_additive_id: this.entity.id
          };
        } else {
          this.audit = {
            irfe_additive_id: this.entity.id
          };
        }
      }
    }
    this.loaded;
  }

  formValue(field) {
    return this.form.get(field)?.value;
  }

  exibeCampos() {
    let tipo = this.formValue('additive_type_id');
    this.exibe_dt_end = (tipo == this.tiposParams.TYPE_PRAZO || tipo == this.tiposParams.TYPE_PRAZO_VALOR);
    this.exibe_transfer_value = (tipo == this.tiposParams.TYPE_VALOR || tipo == this.tiposParams.TYPE_PRAZO_VALOR);
    this.exibe_counterpart_value = this.exibe_transfer_value;
  }

  maskCurrency(event, field) {
    let value = this.maskService.formatarMedidaFisica(event.target?.value, 2, 14);
    this.form.get(field).setValue(value);
  }


  getDataCreate(): AditivoIrcpIrfe {
    let data: AditivoIrcpIrfe;

    data = Object.assign({}, data, this.form.value);

    if (this.isIrcp) {
      data.ircp_id = this.myId;
    } else {
      data.irfe_id = this.myId;
    }
    if (!this.verificaFormatoData(data.dt_end)) {
      data.dt_end = formatDate(data.dt_end, 'DD/MM/YYYY');
    }

    return data;
  }

  voltar() {
    if (this.isIrcp) {
      this.navigation.back([`projetos/projeto/${this.idProjeto}/ircp/${this.myId}`]);
    } else {
      this.navigation.back([`projetos/projeto/${this.idProjeto}/irfe/${this.myId}`]);
    }
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      if (this.entity?.id) {
        this.addSub(
          this.myService.aditivoUpdate(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: AditivoIrcpIrfe) => {
              this.msgSuccess('Aditivo alterado com sucesso!')
              this.loaded();
              this.voltar();
            },
            error: (error) => {
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.aditivoCreate(this.getDataCreate()).subscribe({
            next: (res: AditivoIrcpIrfe) => {
              this.msgSuccess('Aditivo cadastrado com sucesso!');
              this.loaded();
              this.voltar();
            },
            error: (error) => {
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.aditivoDelete(this.entity.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.voltar();
        });
      },
      error: (error) => {
        this.loaded();
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
      }
    });
  }

}
